import React from 'react';
import {
    BrowserRouter as Router,
 
    withRouter,

} from "react-router-dom";

import HOne from "../../components/h-one";

import ServerApi from '../../services/server-api-service';
import ConfigurationService from '../../services/configuration-service';
import StringProcessingService from '../../services/string-processing-service.js';
import UserForm from '../../components/user-form';
import Modal from '../../components/modal';
import Helmet from 'react-helmet';
import ActivityWatcher from '../../functions/user-activity/user-activity.js'
import CookiesManager from '../../services/cookies-manager';
import SeoService from '../../services/seo-service';
import Footer from '../../components/footer/footer.js';
import { ThirtyFpsRounded } from '@mui/icons-material';


function customCampaignLogic(WrappedComponent){
    return class extends React.Component {
        serverApi = new ServerApi()
        configurationService = new ConfigurationService();
        stringProcessingService = new StringProcessingService();
        cookiesManager = new CookiesManager();
        date = new Date();
        seoService = new SeoService();
        constructor(props) {
            super(props)
            this.state = {
                debug: false,

                modals:{
                    settings:{
                        isVisibleMessageScrollFlag: true,
                        onStartPopUp: false,
                        advertisitingSettings:{
                            inputBans:{
                                email: false,
                                phone: false,
                                message: true,
                                comment: true,
                            }

                        }
                    },
                    views:{
                        // isVisibleModalTop: true,
                        // isVisibleModalBottom: false,
                        // isVisibleModalBottomMobile: true,
                        isVisibleMessage: false,
                        isVisibleModalAdvertising: false,
                    }
                },
                currentSettings:null,
                currentSlideBottomMobile: 0,
                currentSlideBottom: 0,
                // isVisibleSchedule: false,
                scheduleForm: {
                    date: `${this.date.getFullYear()}-0${this.date.getMonth() + 1}-0${this.date.getDate()}`
                },
                contactForm: {
                    userFullName: '',
                    userPhone: '',
                    userEmail: '',
                    userMessage: '',
                    project: ''
                },
                selectedCountry: null,
                customDictionary: null,
                footerLogo: null,

            }

        }

        getSettings(){

            let {width} = this.props;
            let subdomain = null;
            // let subdomain = this.configurationService.getSubdomain();

            this.serverApi.getLandingDefaultSettings()
            .then((data) => {

                let currentSettings = null;
                let settings = null;

                if(document.location.search == null || document.location.search =='?debug=true'){
                    settings = data.without_params;
                }else{
                    settings = data.with_params;
                }

                if(subdomain) currentSettings = settings.subdomain_options
                else currentSettings = settings.regular_options


                if(width > 1000){
                    if((currentSettings && currentSettings.popup)){

                        let searchParams = new URLSearchParams(document.location.search);
                        let hideEmail = true, hidePhone = true;

                        if(searchParams.get('email') == 'true' || currentSettings.popup_email) hideEmail = false
                        if(currentSettings.popup_phone) hidePhone = false

                        this.setState(prevState => {
                        return {
                            modals:{
                                ...this.state.modals,
                                settings:{
                                    ...this.state.modals.settings,
                                    advertisitingSettings:{
                                        ...this.state.modals.settings.advertisitingSettings,
                                        inputBans:{
                                            ...this.state.modals.settings.advertisitingSettings.inputBans,
                                            email: hideEmail,
                                            phone: hidePhone
                                        }
                                    }
                                },
                                views:{
                                    ...this.state.modals.views,
                                }
                            }
                        }
                        })

                        if(currentSettings.popup){
                            this.openModal('isVisibleModalAdvertising');
                        }

                    }

                }


                this.saveState({
                    currentSettings: currentSettings
                })
            })
            .catch((error) => {
                console.log(`ERROR: fetch getLandingSettings ... -> Component: ProjectCompanyPage ERROR:${error}`);
            })
        }

        componentDidMount() {

            let {saveState, history, match,width} = this.props;
            let {currentSettings} = this.state;

            // let initialData = {
            //     selectionHeader: true,
            //     showSelectionToolBar: false,
            //     footerHideElem: true,
            //     currentPage: 'ProjectCompanyPage',
            // }
            // saveState(initialData);
            this.getSettings();
            this.watcher = new ActivityWatcher('openMessageModal');
            document.addEventListener('openMessageModal', this.openMessageModal)

            // if(!match.params.id){
            //     let subdomain = this.configurationService.getSubdomain();
            //     if(subdomain){
            //     this.serverApi.getProjectInfoBySubdomain(subdomain)
            //         .then((data) => {
            //             this.saveApiData(data);
            //         })
            //         .catch((error) => {
            //             console.log(`ERROR: fetch getProjectInfo ... -> Component: ProjectCompanyPage ERROR:${error}`);
            //         history.replace({ pathname: `/page-not-found` });
            //         })
            //     }
            // }else{

            //     this.serverApi.getProjectInfo(match.params.id)
            //     .then((data) => {
            //         this.saveApiData(data);
            //     })
            //     .catch((error) => {
            //         console.log(`ERROR: fetch getProjectInfo ... -> Component: ProjectCompanyPage ERROR:${error}`);
            //         history.replace({ pathname: `/page-not-found` });
            //     })

            // }

            let searchParams = new URLSearchParams(document.location.search);

            if(document.location.search.length > 0 && width > 1000 && document.location.search !== '?debug=true'){
                if(searchParams.get('option') != 'open'){

                    let hideEmail = true;
                    if(searchParams.get('email') == 'true') hideEmail = false

                    this.openModal('isVisibleModalAdvertising',{
                        ...this.state.modals.settings,
                        advertisitingSettings:{
                            inputBans:{
                                ...this.state.modals.settings.advertisitingSettings.inputBans,
                                email: hideEmail,
                            }
                        }
                    })
                    // this.setState({
                    //     isVisibleModalAdvertising:true
                    // })
                }

            }

            //non domain page


            if(document.location.search.includes('onstart=true')){
                this.openModal('isVisibleMessage',{onStartPopUp:true})

                // this.setState({
                //     isVisibleMessage:true,
                //     onStartPopUp:true,
                // })
            }
        }


        componentWillUnmount() {
            document.removeEventListener('openMessageModal', this.openMessageModal);
            // let initialData = {
            //     currentProjectLogo: null,
            //     footerHideElem: false,
            //     allowedLanguages: null,
            // }
            // this.props.saveState(initialData);
        }

        componentDidUpdate(prevProps) {
        
            let {settings, views} = this.state.modals

            let exitPop = this.cookiesManager.get('exit_pop');
            let windowRelativeBottom = document.documentElement.getBoundingClientRect().bottom;
            if ((windowRelativeBottom < ((document.documentElement.clientHeight + document.getElementsByClassName('Footer')[0].clientHeight) + (this.props.mobileVerison ? 1 : 0)) && prevProps.pageScroll < this.props.pageScroll)
                || (this.props.mouseEvent != null && this.props.mouseEvent.clientY < 5)) {
                if ((views.isVisibleMessage !== true && settings.isVisibleMessageScrollFlag) && exitPop == null) {
                    this.openModal('isVisibleMessage')
                }
            }
        }

        

        openMessageModal = () => {
            let exitPop = this.cookiesManager.get('exit_pop');

            let {isVisibleMessage} = this.state.modals.views
            let {isVisibleMessageScrollFlag} = this.state.modals.settings

            if (!isVisibleMessage && isVisibleMessageScrollFlag && exitPop == null) {
                this.openModal('isVisibleMessage');
                // this.setState({
                //     isVisibleMessage: true
                // })
            }
        }

        handleInput = (event) => {
            let { name, value } = event.target;
            this.setState((prevState) => {
                return {
                    contactForm: {
                        ...prevState.contactForm,
                        [name]: value
                    }
                }
            })
        }

        handleInputSchedule = (e) => {
            this.setState((prevState) => {
                return {
                    scheduleForm: {
                        [e.target.name]: e.target.value
                    }
                }
            })
        }

    
        clearForm = () => {
            // this.setState({
            //     ...this.state,
            //     contactForm: {
            //         userFullName: '',
            //         userPhone: '',
            //         userEmail: '',
            //         userMessage: '',
            //         userComment: ''
            //     },
            // })
        }

        closeModal = (isVisibleMessageScrollFlag = false) => {

            if (this.cookiesManager.get('exit_pop') == null) {
                this.cookiesManager.set('exit_pop', 1, 30)
            }
            this.setState((prevState)=>{
                return {

                    modals:{
                        settings:{
                            ...this.state.modals.settings,
                            onStartPopUp:false,
                            isVisibleMessageScrollFlag: isVisibleMessageScrollFlag
                        },
                        views:{
                            isVisibleModalTop: false,
                            isVisibleModalBottom: false,
                            isVisibleModalBottomMobile: false,
                            isVisibleModalAdvertising: false,
                            isVisibleMessage: false,
                        }
                    }
                }
            })

        }

        openModal(modal, newSettings ){
            let {settings, views} = this.state.modals;

            for(const modalView in views){
                if(views[modalView]) return;
            }

            this.setState({
                modals:{
                    settings: {
                        ...settings,
                        newSettings
                    },
                    views:{
                        ...views,
                        [modal]:true
                    }
                }
            })
        }

        setStateLogic(state){
            this.setState({
                ...this.state,
                footerLogo:state.footerLogo,
                customDictionary: state.customDictionary,
              
            })

            this.setState((prevState) => {
                return {
                    contactForm: {
                        ...prevState.contactForm,
                        project: state.customDictionary.campaign_name
                    }
                }
            })
        }
        // renderModal(isVisible, images, currentSlide, mobile = false, modalClass = '') {
        //     let exitPopUp = this.cookiesManager.get('exit_pop');
        //     let { dictionary, country, width } = this.props;
        //     let { data } = this.state;
        //     if (width > 300 && exitPopUp == null) {
        //         return (
        //             <>
        //                 <Modal
        //                     ModalBlurStyle={{ backgroundColor: "rgba(0,0,0,0.85)" }}
        //                     modalClass={modalClass}
        //                     ModalStyle={{ height: "100%", boxShadow: 'none', backgroundColor: 'unset', width: "100%", justifyContent: 'center', flexDirection: 'column' }}
        //                     closeModal={this.closeModal}
        //                     closeColor={'#fff'}
        //                     isVisible={isVisible}
        //                 >
        //                     <ProjectSliderModal
        //                         mobile={mobile}
        //                         projectData={data}
        //                         data={images}
        //                         width={width}
        //                         dictionary={dictionary}
        //                         closeModal={this.closeModal}
        //                         currentSlide={currentSlide}
        //                         country={country}
        //                     />

        //                 </Modal>
        //             </>
        //         )
        //     } else return null;
        // }

        render() {

            let { contactForm, sliderData, data, selectedCountry, currentJumbo, currentProjectLogo,
                currentSlideTop, currentSlideBottom, topSliderImages,
                currentSlideBottomMobile ,onStartPopUp, modals, footerLogo, customDictionary, lang = 'en'} = this.state;



            let {isVisibleModalBottom, isVisibleModalTop,
                isVisibleModalBottomMobile, isVisibleMessage,isVisibleModalAdvertising} = this.state.modals.views;

            let { dictionary, width, country, pageScroll, mobileVerison, height,neighboorhoods} = this.props;

        const smart_luxe_logo_but = require('../../elements/images/invest/smart_luxe_logo_but.png');
                // console.log('data.urgency', data.urgency);
                return (
                    <div  className="customCampaigns">
                  
                               <WrappedComponent
                                    {...this.props}
                                    setStateLogic = {this.setStateLogic.bind(this)} 
                                    openModal ={this.openModal.bind(this)}
                                    watcher ={this.watcher}
                                />
                            <Footer
                                dictionary={dictionary}
                                neighboorhoods={neighboorhoods}
                                currentProjectLogoInvert={footerLogo}
                                hideElems={null}
                            />


                         <Modal
                            ModalBlurStyle={{ backgroundColor: "rgba(0,0,0,0.85)" }}
                            closeModal={this.closeModal.bind(this, false)}
                            modalClass={'MessageModal'}
                            closeColor={'#000'}
                            speed={0.5}
                            ModalStyle={{ justifyContent: 'center', flexDirection: 'column', padding: "20px", alignItems: 'center' }}
                            isVisible={isVisibleMessage}
                            onStartPopUp={onStartPopUp}
                            >
                            <HOne addclass={"xsmall"} align={"center"} title={`${dictionary.request_about}`} line={"none"} />
                            <UserForm
                                closeModal={this.closeModal.bind(this)}
                                watcher={this.watcher}
                                className="MobileMessageModal"
                                thankModal={true}
                                inputBans={{ comment: true, message: true, email:false }}
                                clearForm={this.clearForm}
                                message={dictionary.thank_you_deal}
                                initialMessage={`${dictionary.send_me_more_details_about_project} test`}
                                selectedCountry={selectedCountry}
                                saveCurrentSelectedCountry={this.saveCurrentSelectedCountry}
                                country={country}
                                topPartRow={true}
                                contactForm={contactForm}
                                handleInput={this.handleInput}
                                width={width}
                                secureInfo={true}
                                dictionary={dictionary}
                                style={{ textAlign: 'center', justifyContent: 'center' }}
                                customDictionary={customDictionary}
                                buttonTitle={customDictionary && customDictionary.submit}
                                lang={lang}
                                CustomInputStyle={{direction:'ltr'}}
                            />
                           
                        </Modal> 




                        <Modal
                            ModalBlurStyle={{ backgroundColor: "rgba(0,0,0,0.85)" }}
                            closeModal={this.closeModal.bind(this)}
                            modalClass={'MessageModal'}
                            hiddenCloseIcon={true}
                            closeColor={'#000'}
                            speed={0.5}
                            ModalStyle={{ justifyContent: 'center', flexDirection: 'column', padding: "20px", alignItems: 'center', width:'30%' }}
                            isVisible={isVisibleModalAdvertising}
                            onStartPopUp={onStartPopUp}
                            >
                            <HOne addclass={"xsmall"} align={"center"} title={dictionary.register_to_access.toUpperCase()} line={"none"} />
                            {/* {data.urgency ?
                                <React.Fragment>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="138.247" height="2" viewBox="0 0 138.247 2">
                                        <defs>
                                            <linearGradient id="linear-gradient" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox">
                                                <stop offset="0" stopColor="#a96903" />
                                                <stop offset="0.258" stopColor="#aa6a02" />
                                                <stop offset="0.352" stopColor="#b07102" />
                                                <stop offset="0.418" stopColor="#b97d02" />
                                                <stop offset="0.472" stopColor="#c78e01" />
                                                <stop offset="0.518" stopColor="#daa401" />
                                                <stop offset="0.557" stopColor="#f0be00" />
                                                <stop offset="0.579" stopColor="#ffd100" />
                                                <stop offset="1" stopColor="#a96903" />
                                            </linearGradient>
                                        </defs>
                                        <br/>
                                        <g id="Сгруппировать_94" data-name="Сгруппировать 94" transform="translate(-2822.173 274.933)">
                                            <rect id="Прямоугольник_18" data-name="Прямоугольник 18" width="138.247" height="2" transform="translate(2822.173 -274.933)" fill="url(#linear-gradient)" />
                                        </g>
                                    </svg>
                                    <br/>
                                    <div className={"FormText"}>
                                        {data.urgency}
                                    </div>
                                </React.Fragment>
                                : (null)
                            } */}
                            <UserForm
                                closeModal={this.closeModal.bind(this)}
                                countryCodeSelector = {true}
                                watcher={this.watcher}
                                className="MobileMessageModal"
                                thankModal={false}
                                inputBans={modals.settings.advertisitingSettings.inputBans}
                                clearForm={this.clearForm}
                                message={dictionary.thank_you_deal}
                                initialMessage={`${dictionary.send_me_more_details_about_project} Test`}
                                selectedCountry={selectedCountry}
                                saveCurrentSelectedCountry={this.saveCurrentSelectedCountry}
                                country={country}
                                topPartRow={true}
                                contactForm={contactForm}
                                handleInput={this.handleInput}
                                width={width}
                                secureInfo={true}
                                dictionary={dictionary}
                                style={{ textAlign: 'center', justifyContent: 'center' }}
                                customDictionary={customDictionary}
                                buttonTitle={customDictionary && customDictionary.form_submit}
                                lang={lang}
                                CustomInputStyle={{direction:'ltr', padding: '0 5px 0 5px'}}
                            />
                        </Modal>


                    </div>

                )
          
        }
    }
}


export default customCampaignLogic;